import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function NameCell({ rowData: { name } }: CellProps) {
  const { searchString } = useSearchContext();
  return <HighlightText text={name} searchText={searchString} />;
}
